export default () => {
  const linksWithHashtag = document.querySelectorAll('a[href*="#"]:not(.rte a)');
  linksWithHashtag.forEach((link: HTMLAnchorElement) => {
    link.addEventListener('click', (event) => {
      event.stopImmediatePropagation();
      event.preventDefault()

      const sectionLinkId = link.href.split('#').pop().toLowerCase();
      const sectionElement: HTMLElement = document.querySelector(`[data-link-id="${sectionLinkId}"]`);

      const headerElement = document.getElementById('shopify-section-header');
      const headerHeight = headerElement ? headerElement.offsetHeight : 0;

      const scrollToPosition = sectionElement.offsetTop - headerHeight;
      window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
    });
  });
}
